import { setEmojiBaseUrl } from '../emoji/utils';
export const sizeValues = ['m', 's', 'xs', 'xxs'];
export const createParseVisitor = doc => {
  let emojiBaseUrl = null;
  return {
    updateEmojiBaseUrl(url) {
      emojiBaseUrl = url;
    },
    createVisitor() {
      const $root = doc.createDocumentFragment();
      let $p = null;
      let $li = null;
      const $lists = [];
      return {
        emoji(emojiChar) {
          const $emoji = doc.createElement('sinch-emoji');
          setEmojiBaseUrl($emoji, emojiBaseUrl);
          $emoji.setAttribute('char', emojiChar);
          $emoji.className = 'emoji';
          $p.appendChild($emoji);
        },
        codetag(text) {
          const $codeTag = doc.createElement('sinch-code-tag');
          $codeTag.text = text;
          $p.appendChild($codeTag);
        },
        inline(text, _ref) {
          let {
            isBold,
            isItalic,
            isStrikethrough
          } = _ref;
          const $inline = doc.createElement('SPAN');
          $inline.append(doc.createTextNode(text));
          if (isItalic === true) {
            $inline.classList.add('em1');
          }
          if (isBold === true) {
            $inline.classList.add('em2');
          }
          if (isStrikethrough === true) {
            $inline.classList.add('strikethrough');
          }
          $p.appendChild($inline);
        },
        linebreak() {
          const $br = doc.createElement('br');
          $p.appendChild($br);
        },
        link(text, href, attributes) {
          const $link = doc.createElement('sinch-link');
          $link.text = text;
          $link.href = href;
          if (attributes != null) {
            attributes.forEach(attr => {
              switch (attr) {
                case 'use-history':
                  $link['use-history'] = true;
                  break;
                case 'external':
                  $link.external = true;
                  break;
                default:
                  break;
              }
            });
          }
          $p.appendChild($link);
        },
        list(isOrdered) {
          const $list = doc.createElement(isOrdered ? 'ol' : 'ul');
          $list.classList.add(isOrdered ? 'ol' : 'ul');
          if ($li !== null) {
            $li.appendChild($list);
            $li = null;
          } else {
            $root.appendChild($list);
          }
          $lists.push($list);
        },
        endList() {
          $p = null;
          $li = null;
          $lists.length = $lists.length - 1;
          if ($lists.length > 0) {
            $li = $lists.at(-1).lastChild;
          }
        },
        listItem() {
          $p = null;
          $li = doc.createElement('li');
          $li.classList.add('li');
          $lists.at(-1).appendChild($li);
        },
        paragraph() {
          $p = doc.createElement('p');
          $p.classList.add('p');
          if ($li !== null) {
            $li.appendChild($p);
          } else {
            $root.appendChild($p);
          }
        },
        end() {
          return $root;
        }
      };
    }
  };
};